import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {EnvironmentService} from '../environment.service';
import {ClientService} from './client.service';

@Injectable({
    providedIn: 'root',
})
export class AuthApiService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvironmentService);
    private readonly clientService = inject(ClientService);

    get<T>(
        path: string,
        options?: {
            headers?: HttpHeaders | { [header: string]: string | string[] };
            params?: HttpParams | {
                [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>
            };
        },
    ) {
        return this.http.get<T>(this.normalize(path), options);
    }

    post<T>(
        path: string,
        body?: unknown,
        options?: {
            headers?: HttpHeaders | { [header: string]: string | string[] };
            params?: HttpParams | {
                [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>
            };
        },
    ) {
        return this.http.post<T>(this.normalize(path), body, options);
    }

    put<T>(
        path: string,
        body?: unknown,
        options?: {
            headers?: HttpHeaders | { [header: string]: string | string[] };
            params?: HttpParams | {
                [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>
            };
        },
    ) {
        return this.http.put<T>(this.normalize(path), body, options);
    }

    delete<T>(
        path: string,
        options?: {
            headers?: HttpHeaders | { [header: string]: string | string[] };
            params?: HttpParams | {
                [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>
            };
        },
    ) {
        return this.http.delete<T>(this.normalize(path), options);
    }

    private withTenant(path: string): string {
        const clientId = (this.clientService.client?.id || '').trim();
        if (!clientId) return path;

        const alreadyScoped = /(?:^|[?&])(tenant_id|tenantId|clientId|client_id)=/i.test(path);
        if (alreadyScoped) return path;

        const delimiter = path.includes('?') ? '&' : '?';
        return `${path}${delimiter}client_id=${encodeURIComponent(clientId)}`;
    }

    private normalize(path: string): string {
        const base = (this.env.authBaseServerUrl || '').replace(/\/+$/, '');
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        return `${base}${this.withTenant(cleanPath)}`;
    }
}
